import { createContext } from "react";
import type { ICategoryLeadersServices } from "../../CategoryLeaders.types";

interface ICategoryLeadersContext {
    services: ICategoryLeadersServices;
}

export const CategoryLeadersContext = createContext<ICategoryLeadersContext>({
    services: null,
});
